(function(){
  if(window.__smsPredictiveSearchLoaded)return;
  window.__smsPredictiveSearchLoaded=true;

  var css=[
    '.sms-predict{position:fixed;z-index:99999;display:none;width:min(960px,calc(100vw - 32px));max-height:min(630px,calc(100vh - 110px));overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;color:var(--c-text,#10272d);background:#fff;border:1px solid rgba(0,91,82,.14);border-radius:20px;box-shadow:0 24px 70px rgba(7,25,34,.2)}',
    '.sms-predict.is-open{display:block}',
    '.sms-predict-head{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:17px 20px;border-bottom:1px solid var(--c-border,#e3e9e7);background:linear-gradient(135deg,#f8fbfa,#edf7f4)}',
    '.sms-predict-query{font-size:13px;font-weight:700}',
    '.sms-predict-query b{color:var(--c-accent,#005b52)}',
    '.sms-predict-close{width:34px;height:34px;padding:0;border:0;border-radius:50%;background:#fff;display:grid;place-items:center;cursor:pointer;font-size:20px;line-height:1}',
    '.sms-predict-body{display:grid;grid-template-columns:minmax(0,1.6fr) minmax(230px,.8fr)}',
    '.sms-predict-main,.sms-predict-side{padding:20px}',
    '.sms-predict-side{border-left:1px solid var(--c-border,#e3e9e7);background:#fbfdfc}',
    '.sms-predict-title{display:flex;align-items:center;justify-content:space-between;margin:0 0 13px;font-size:15px;font-weight:800}',
    '.sms-predict-count{min-width:24px;height:24px;padding:0 8px;border-radius:99px;background:#e8f4f1;color:var(--c-accent,#005b52);display:grid;place-items:center;font-size:10px}',
    '.sms-predict-products{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}',
    '.sms-predict-product{min-width:0;text-decoration:none!important;color:inherit!important;border:1px solid var(--c-border,#e3e9e7);border-radius:14px;overflow:hidden;background:#fff;transition:transform .2s,border-color .2s,box-shadow .2s}',
    '.sms-predict-product:hover{transform:translateY(-2px);border-color:rgba(0,91,82,.35);box-shadow:0 10px 24px rgba(0,91,82,.09)}',
    '.sms-predict-product-img{display:block;aspect-ratio:1/1;background:#f3f8f6;overflow:hidden}',
    '.sms-predict-product-img img{width:100%;height:100%;object-fit:contain;display:block}',
    '.sms-predict-product-info{display:block;padding:11px}',
    '.sms-predict-product-name{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;min-height:34px;font-size:12px;line-height:1.4;font-weight:700}',
    '.sms-predict-price{display:block;margin-top:7px;color:var(--c-accent,#005b52);font-size:12px;font-weight:800}',
    '.sms-predict-cats{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:22px}',
    '.sms-predict-cat{padding:9px 11px;text-decoration:none!important;color:inherit!important;border:1px solid var(--c-border,#e3e9e7);border-radius:10px;background:#fff;font-size:11px;font-weight:700}',
    '.sms-predict-cat:hover{border-color:var(--c-accent,#005b52);color:var(--c-accent,#005b52)!important}',
    '.sms-predict-articles{display:grid;gap:10px}',
    '.sms-predict-article{display:grid;grid-template-columns:58px minmax(0,1fr);gap:10px;align-items:center;text-decoration:none!important;color:inherit!important}',
    '.sms-predict-article-img{width:58px;height:48px;border-radius:9px;overflow:hidden;background:#edf6f3}',
    '.sms-predict-article-img img{width:100%;height:100%;object-fit:cover;display:block}',
    '.sms-predict-article-name{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;font-size:11px;line-height:1.4;font-weight:700}',
    '.sms-predict-all{display:flex;align-items:center;justify-content:center;gap:8px;margin:0 20px 20px;padding:13px 18px;border-radius:12px;background:var(--c-accent,#005b52);color:#fff!important;text-decoration:none!important;font-size:12px;font-weight:800}',
    '.sms-predict-empty,.sms-predict-loading{padding:38px 20px;text-align:center;color:var(--c-muted,#53636b);font-size:13px}',
    '.sms-predict-loading:before{content:"";display:inline-block;width:16px;height:16px;margin-right:9px;border:2px solid #cfe2de;border-top-color:var(--c-accent,#005b52);border-radius:50%;vertical-align:-3px;animation:smsPredictSpin .7s linear infinite}',
    '@keyframes smsPredictSpin{to{transform:rotate(360deg)}}',
    '@media(max-width:989px){.sms-predict{width:calc(100vw - 24px);max-height:calc(100vh - 100px);border-radius:16px}.sms-predict-body{display:block}.sms-predict-side{border-left:0;border-top:1px solid var(--c-border,#e3e9e7)}.sms-predict-products{grid-template-columns:repeat(2,minmax(0,1fr))}.sms-predict-product:nth-child(n+5){display:none}}'
  ].join('');

  var style=document.createElement('style');
  style.id='sms-predictive-search-style';
  style.textContent=css;
  document.head.appendChild(style);

  var locale=(document.documentElement.lang||'fr').toLowerCase();
  var lang=locale.split('-')[0];
  var dictionary={
    fr:{products:'Produits',categories:'Cat\u00e9gories',articles:'Articles & conseils',all:'Voir tous les r\u00e9sultats',none:'Aucun r\u00e9sultat trouv\u00e9',loading:'Recherche...',forText:'R\u00e9sultats pour',close:'Fermer'},
    en:{products:'Products',categories:'Categories',articles:'Articles & advice',all:'View all results',none:'No results found',loading:'Searching...',forText:'Results for',close:'Close'},
    it:{products:'Prodotti',categories:'Categorie',articles:'Articoli e consigli',all:'Vedi tutti i risultati',none:'Nessun risultato',loading:'Ricerca...',forText:'Risultati per',close:'Chiudi'}
  };
  var text=dictionary[lang]||dictionary.fr;

  var localProductIndex;

  function normalizeSearchValue(value){
    var normalized=String(value==null?'':value).toLowerCase();
    if(normalized.normalize){
      normalized=normalized.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    }
    return normalized.replace(/[^a-z0-9]+/g,' ').trim();
  }

  function searchTermsFor(query){
    var normalizedQuery=normalizeSearchValue(query);
    var terms=[normalizedQuery];
    if(normalizedQuery.length>=3&&'vitamine'.indexOf(normalizedQuery)===0){
      terms=terms.concat([
        'vitamin','vitamine','biotin','biotine','thiamin','riboflav',
        'niacin','nicotinamid','pantoth','pyridoxin','folat','folic',
        'cobalamin','ascorb','retinol','beta carot','calciferol',
        'cholecalciferol','ergocalciferol','tocopherol','phylloquin',
        'menaquin'
      ]);
    }
    return terms.filter(function(term,index,list){
      return term&&list.indexOf(term)===index;
    });
  }

  function canonicalProductUrl(value){
    try{
      return new URL(value,window.location.origin).pathname.replace(/\/+$/,'');
    }catch(error){
      return String(value||'').split('?')[0].replace(/\/+$/,'');
    }
  }

  function getLocalProductMatches(query){
    if(localProductIndex===undefined){
      localProductIndex=[];
      var indexElement=document.getElementById('sms-search-product-index');
      if(indexElement){
        try{
          localProductIndex=JSON.parse(indexElement.textContent)||[];
        }catch(error){}
      }
    }

    var terms=searchTermsFor(query);
    if(!terms.length)return[];

    return localProductIndex.filter(function(product){
      var searchable=[
        product.title,
        product.tags,
        product.ingredients
      ].map(normalizeSearchValue).join(' ');
      return terms.some(function(term){
        return searchable.indexOf(term)!==-1;
      });
    }).map(function(product){
      return{
        title:product.title,
        url:product.url,
        featured_image:{url:product.image},
        price:{amount:product.price}
      };
    });
  }

  function escapeHtml(value){
    return String(value==null?'':value).replace(/[&<>"']/g,function(character){
      return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];
    });
  }

  function itemImage(item){
    var image=item&&(item.featured_image||item.image);
    return image&&(image.url||image);
  }

  function formatMoney(value){
    var amount=parseFloat(value&&value.amount!=null?value.amount:value);
    if(!isFinite(amount))return'';
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    try{
      return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(amount);
    }catch(error){
      return amount.toFixed(2)+' '+currency;
    }
  }

  function initialise(root){
    if(!root||root.dataset.predictiveSearchReady==='1')return;
    root.dataset.predictiveSearchReady='1';

    var inputs=root.querySelectorAll('.sms-search-inline input[name="q"],.sms-m-search input[name="q"]');
    if(!inputs.length)return;

    var panel=document.createElement('div');
    var activeInput=null;
    var timer=null;
    var request=null;
    var latestQuery='';

    panel.className='sms-predict';
    panel.setAttribute('role','region');
    panel.setAttribute('aria-live','polite');
    document.body.appendChild(panel);

    function closePanel(){
      panel.classList.remove('is-open');
      panel.innerHTML='';
    }

    function positionPanel(){
      if(!activeInput||!panel.classList.contains('is-open'))return;
      var rectangle=activeInput.closest('form').getBoundingClientRect();
      var width=Math.min(960,window.innerWidth-32);
      var left=Math.max(12,Math.min(window.innerWidth-width-12,rectangle.left+rectangle.width/2-width/2));
      panel.style.width=width+'px';
      panel.style.left=left+'px';
      var top=Math.min(window.innerHeight-90,rectangle.bottom+10);
      panel.style.top=top+'px';
      panel.style.maxHeight=Math.max(180,window.innerHeight-top-12)+'px';
    }

    function openPanel(html){
      panel.innerHTML=html;
      panel.classList.add('is-open');
      positionPanel();
    }

    function panelHeader(query){
      return'<div class="sms-predict-head"><div class="sms-predict-query">'+escapeHtml(text.forText)+' <b>&laquo; '+escapeHtml(query)+' &raquo;</b></div><button class="sms-predict-close" type="button" aria-label="'+escapeHtml(text.close)+'">&times;</button></div>';
    }

    function imageHtml(url,alt,className){
      return'<span class="'+className+'">'+(url?'<img src="'+escapeHtml(url)+'" alt="'+escapeHtml(alt)+'" loading="lazy">':'')+'</span>';
    }

    function render(query,data){
      var results=data&&data.resources&&data.resources.results||{};
      var products=results.products||[];
      var collections=results.collections||[];
      var articles=results.articles||[];
      var uniqueProducts=[];
      products.concat(getLocalProductMatches(query)).forEach(function(product){
        var productKey=canonicalProductUrl(product.url);
        var alreadyPresent=uniqueProducts.some(function(existing){
          return canonicalProductUrl(existing.url)===productKey;
        });
        if(!alreadyPresent)uniqueProducts.push(product);
      });
      products=uniqueProducts;

      if(!products.length&&!collections.length&&!articles.length){
        openPanel(panelHeader(query)+'<div class="sms-predict-empty">'+escapeHtml(text.none)+'</div>');
        return;
      }

      var main='';
      var side='';

      if(products.length){
        main='<div class="sms-predict-main"><div class="sms-predict-title"><span>'+escapeHtml(text.products)+'</span><span class="sms-predict-count">'+products.length+'</span></div><div class="sms-predict-products">';
        products.slice(0,9).forEach(function(product){
          main+='<a class="sms-predict-product" href="'+escapeHtml(product.url)+'">'+imageHtml(itemImage(product),product.title,'sms-predict-product-img')+'<span class="sms-predict-product-info"><span class="sms-predict-product-name">'+escapeHtml(product.title)+'</span><span class="sms-predict-price">'+escapeHtml(formatMoney(product.price))+'</span></span></a>';
        });
        main+='</div></div>';
      }

      if(collections.length){
        side+='<div class="sms-predict-title"><span>'+escapeHtml(text.categories)+'</span><span class="sms-predict-count">'+collections.length+'</span></div><div class="sms-predict-cats">';
        collections.slice(0,5).forEach(function(collection){
          side+='<a class="sms-predict-cat" href="'+escapeHtml(collection.url)+'">'+escapeHtml(collection.title)+'</a>';
        });
        side+='</div>';
      }

      if(articles.length){
        side+='<div class="sms-predict-title"><span>'+escapeHtml(text.articles)+'</span><span class="sms-predict-count">'+articles.length+'</span></div><div class="sms-predict-articles">';
        articles.slice(0,4).forEach(function(article){
          side+='<a class="sms-predict-article" href="'+escapeHtml(article.url)+'">'+imageHtml(itemImage(article),article.title,'sms-predict-article-img')+'<span class="sms-predict-article-name">'+escapeHtml(article.title)+'</span></a>';
        });
        side+='</div>';
      }

      var searchRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var searchUrl=searchRoot+'search?q='+encodeURIComponent(query)+'&type=product%2Carticle&options%5Bprefix%5D=last&sort_by=relevance';
      openPanel(panelHeader(query)+'<div class="sms-predict-body">'+main+(side?'<aside class="sms-predict-side">'+side+'</aside>':'')+'</div><a class="sms-predict-all" href="'+escapeHtml(searchUrl)+'">'+escapeHtml(text.all)+' &laquo; '+escapeHtml(query)+' &raquo; &rarr;</a>');
    }

    function search(input){
      var query=input.value.trim();
      activeInput=input;
      latestQuery=query;
      clearTimeout(timer);

      if(query.length<2){
        if(request)request.abort();
        closePanel();
        return;
      }

      timer=setTimeout(function(){
        if(request)request.abort();
        request=new AbortController();
        openPanel(panelHeader(query)+'<div class="sms-predict-loading">'+escapeHtml(text.loading)+'</div>');

        var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        var url=rootUrl+'search/suggest.json?q='+encodeURIComponent(query)+'&resources%5Btype%5D=product%2Ccollection%2Carticle&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bfields%5D=title%2Ctag&resources%5Boptions%5D%5Bunavailable_products%5D=last';

        fetch(url,{signal:request.signal,headers:{Accept:'application/json'}})
          .then(function(response){
            if(!response.ok)throw new Error('Predictive search failed');
            return response.json();
          })
          .then(function(data){
            if(query===latestQuery)render(query,data);
          })
          .catch(function(error){
            if(error.name!=='AbortError'&&query===latestQuery){
              openPanel(panelHeader(query)+'<div class="sms-predict-empty">'+escapeHtml(text.none)+'</div>');
            }
          });
      },250);
    }

    inputs.forEach(function(input){
      input.setAttribute('aria-autocomplete','list');
      input.addEventListener('input',function(){search(input);});
      input.addEventListener('focus',function(){
        if(input.value.trim().length>=2)search(input);
      });

    });

    panel.addEventListener('click',function(event){
      if(event.target.closest('.sms-predict-close'))closePanel();
    });

    document.addEventListener('click',function(event){
      var clickedInput=Array.prototype.some.call(inputs,function(input){return input===event.target;});
      if(!panel.contains(event.target)&&!clickedInput)closePanel();
    });

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape')closePanel();
    });

    window.addEventListener('resize',positionPanel,{passive:true});
    window.addEventListener('scroll',positionPanel,{passive:true});
  }

  function initialiseAll(){
    document.querySelectorAll('[data-id="mm"]').forEach(initialise);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initialiseAll);
  }else{
    initialiseAll();
  }

  document.addEventListener('shopify:section:load',initialiseAll);

  /* The custom header can be rebuilt after page load. Reconnect automatically. */
  var observer=new MutationObserver(function(){
    initialiseAll();
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();